export const store = selectedStore => ({
  read() {
    return selectedStore();
  },
});
